import { apiRequest } from '../client'

export interface PricingImportItem {
  sku: string
  priceGrossCents: number
}

export interface PricingImportRequest {
  restaurantId: number
  items: Array<PricingImportItem>
}

export interface PricingImportResponse {
  ok: boolean
  updated: number
}

export const pricingApi = {
  import: (data: PricingImportRequest) =>
    apiRequest<PricingImportResponse>('/api/v0/admin/pricing/import', {
      method: 'POST',
      body: JSON.stringify(data),
    }),
}
